import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '@/lib/api';
import { useAuth } from '@/lib/auth';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser, setPermissions, setModuleFlags } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');
    if (!sessionId) {
      navigate('/admin/login');
      return;
    }

    (async () => {
      try {
        const res = await authApi.exchangeSession(sessionId);
        setUser(res.data);
        setPermissions(res.data.permissions || {});
        setModuleFlags(res.data.moduleFlags || {});
        navigate('/admin', { state: { user: res.data }, replace: true });
      } catch (error) {
        // If 403 Forbidden (email not in whitelist), redirect with error param
        if (error.response?.status === 403) {
          navigate('/admin/login?error=forbidden', { replace: true });
        } else {
          navigate('/admin/login', { replace: true });
        }
      }
    })();
  }, [navigate, setUser, setPermissions, setModuleFlags]);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-garden-800 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-charcoal font-body">Connexion en cours...</p>
      </div>
    </div>
  );
}
